export default "__VITE_ASSET__B$6l8byg__"